<modal-layout-right [modalTitle]="'Warranty & Returns'">
    <div modalBody>
        @if (product?.data?.warranty) {
        <p class="p1"
           [innerHTML]="product.data.warranty"></p>
        }
    </div>
</modal-layout-right>
